export class DataMartConstants {
    static QueryParams = {
        TABLE_NAME: 'tablename',
        FIELD_NAME: 'fieldname',
        DIVISION: 'division',
        SEARCH_TERM: 'searchterm',
        LEVEL: 'level',
        LIMIT: 'limit',
        QUERY: 'query',
    };

    static DefaultSalesHistoryTable = 'f_sls_cmt_summ';
    static DefaultSalesHistoryCmtColumn = 'cmt_lvl';
    static DefaultSalesHistorySelfMfgColumn = 'is_self_mfg_flg';
    static DefaultSalesHistorySspColumn = 'ssp_flag';
    static DefaultSalesHistoryChannelsColumn = 'ord_entry_type';
    static DefaultSalesHistoryMetricsColumn = 'Metric';
    static DefaultSalesHistoryProductLabelColumn = 'prd_label_type';

    static DefaultSalesHistoryVendorsTable = 'd_suplr';
    static DefaultSalesHistoryVendorsColumn = 'suplr_nm_nbr';

    static DefaultWebActivityTable = 'f_web_act_segment';
    static DefaultWebActivityCmtColumn = 'cmt_lvl';

    static FieldTypes = {
        Text: ['varchar', 'string'],
        Numeric: ['numeric', 'number', 'integer'],
        Date: ['date', 'timestamp'],
        Boolean: ['boolean'],
    };
}
